export default class MenuItem {
  type = 'menu-item';

  constructor(params) {
    this.name = params.name;
    this.displayName = params.displayName;
    this.excludedLabels = params.excludedLabels;
    this.routeName = params.routeName;
    this.query = params.query;
    return this;
  }
}
